import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AdminContext } from '../../../../context/admin-context';
import './event-item-style.css';

const getLink = (data) => {
  let link = '/';

  if (data.section === 'comment') {
    link = `/post/${data.section_dependency}`;
  } else if (data.section === 'direct') {
    link = `/direct/${data.section_dependency}`;
  }

  return link;
};

const EventItem = ({ data, onNavigate }) => {
  const { events } = useContext(AdminContext);

  const link = getLink(data);

  const { seen, id, section, replies, section_dependency, dependency_data } = data;
  const dependency = dependency_data && typeof dependency_data === 'object' ? dependency_data : {};
  const fullname = dependency.fullname || '—';
  const mobile = dependency.mobile || '';
  const isUnseen = parseInt(seen, 10) === 0;

  const handleSeen = () => {
    if (isUnseen) {
      events.eventSeen({ id, section, section_dependency });
    }
  };

  const title = section === 'comment' ? 'نظر جدید' : section === 'direct' ? 'پیام جدید' : 'رویداد جدید';

  return (
    <li
      className={`admin-event-item admin-event-item--${section} list-item close-menu${isUnseen ? ' is-unseen' : ''}`}
      onClick={handleSeen}
    >
      <Link to={link} className="admin-event-item-link" onClick={onNavigate}>
        <div className="admin-event-item-head">
          <div className="admin-event-item-title-row">
            <span className="admin-event-item-title">{title}</span>
            <span className="admin-event-item-title-badges">
              {isUnseen ? <span className="admin-event-item-new-badge">جدید</span> : null}
              {section === 'comment' && replies ? <span className="admin-event-item-badge">پاسخ داده شد</span> : null}
            </span>
          </div>
        </div>

        <div className="admin-event-item-person">
          <span className="admin-event-item-name">{fullname}</span>
          {mobile ? <span className="admin-event-item-mobile">{mobile}</span> : null}
        </div>
      </Link>
    </li>
  );
};

export default EventItem;
